import { useState } from 'react';

import { Box, Skeleton, Snackbar } from '@parspec/pixel';

import { Header } from './Header';
import { LocationCard } from './LocationCard';
import { SnackbarDataInterface } from './utils/helperTypes';
import { useCompanyInfoQuery } from './queries';
import { useGetUserProfileInfoQuery } from '../MyProfile/queries';
import { DeleteLocationModal } from './Modals/DeleteLocationModal';
import { AddEditLocContextProvider } from './AddEditLocation/context';
import { MaxLocationLimitReachedModal } from './shared/components/MaxLocationReachedModal';
import { MAX_LOCATION_PERMITTED_BY_PLAN } from 'src/features/shared/constants';
import { useSubscriptionInfo } from '../PlanAndPayment/queries';

export const BranchLocations = () => {

    const { data: userProfile, isLoading: isAdminLoading } = useGetUserProfileInfoQuery();
    const { data: companyInfo, isLoading } = useCompanyInfoQuery();
    const [snackbarData, setSnackbarData] = useState<SnackbarDataInterface>({
        isActive: false,
        message: ''
    });
    const { data: subscriptionInfoData, isLoading: isSubscriptionInfoLoading } = useSubscriptionInfo();
    const [isDeleteLocationModalOpen, setIsDeleteLocationModalOpen] = useState<boolean>(false);
    const [selectedLocation, setSelectedLocation] = useState<number>(0);
    const [isMaxLocationReachedModalOpen, setIsMaxLocationReachedModalOpen] = useState(false);

    const CURRENT_PLAN = subscriptionInfoData?.data.my_plan.plan || 'Silver';
    const maxLocationPermitted = MAX_LOCATION_PERMITTED_BY_PLAN[CURRENT_PLAN as keyof typeof MAX_LOCATION_PERMITTED_BY_PLAN];

    const closeModalHandler = () => setIsMaxLocationReachedModalOpen(false);


    return (
        <>
            <Box width="calc(100vw - 390px)" position="relative" overflow="hidden" height={'82vh'} bgcolor="primary.contrastText">
                <AddEditLocContextProvider>
                    <Box p={6} pb={0} position={'absolute'} zIndex={1} width="100%" bgcolor="primary.contrastText">
                        <Header isAdminLoading={isAdminLoading} userProfile={userProfile} setIsMaxLocationReachedModalOpen={setIsMaxLocationReachedModalOpen} maxLocationPermitted={maxLocationPermitted} />
                    </Box>

                    <Box p={6} mb={15} sx={{ overflowY: 'scroll' }} mt={30} height={'70vh'}>
                        <Box display={'flex'} flexWrap={'wrap'} gap={6}>
                            {!isLoading && !isSubscriptionInfoLoading && companyInfo && companyInfo.data.length > 0 ? (
                                companyInfo.data.map((item: any) => (
                                    <LocationCard
                                        userProfile={userProfile}
                                        key={item.id}
                                        locationId={item.id}
                                        locationLogo={item.logo}
                                        locationName={item?.name}
                                        locationAddress1={item?.address1}
                                        locationAddress2={item?.address2}
                                        locationEmail={item?.email}
                                        locationPhone1={item?.phone1}
                                        setIsDeleteLocationModalOpen={setIsDeleteLocationModalOpen}
                                        setSelectedLocation={setSelectedLocation}
                                        setIsMaxLocationReachedModalOpen={setIsMaxLocationReachedModalOpen}
                                        maxLocationPermitted={maxLocationPermitted}
                                    />
                                ))
                            ) : (
                                <>
                                    <Skeleton height={340} width={250} variant="rectangular" sx={{ borderRadius: 1 }} />
                                    <Skeleton height={340} width={250} variant="rectangular" sx={{ borderRadius: 1 }} />
                                    <Skeleton height={340} width={250} variant="rectangular" sx={{ borderRadius: 1 }} />
                                </>
                            )}
                        </Box>
                    </Box>
                </AddEditLocContextProvider>

                <DeleteLocationModal
                    isOpen={isDeleteLocationModalOpen}
                    setIsOpen={setIsDeleteLocationModalOpen}
                    currentLocationId={selectedLocation}
                    snackbarData={snackbarData}
                    setSnackbarData={setSnackbarData}
                />
            </Box>

            <MaxLocationLimitReachedModal isOpen={isMaxLocationReachedModalOpen} onClose={closeModalHandler} maxLocationPermitted={maxLocationPermitted} />


            {<Snackbar open={snackbarData.isActive} message={snackbarData.message} onClose={() => setSnackbarData({ ...snackbarData, isActive: false, message: '' })} />}
        </>
    );
};
